import { Type } from '@angular/core';
import { SlideType } from '../../../models/preview/preview.models';
import { BestTimeToPostSlideComponent } from '../slides/best-time-to-post-slide/best-time-to-post-slide.component';
import { EmotionAnalysisSlideComponent } from '../slides/emotion-analysis-slide/emotion-analysis-slide.component';
import { ExecutiveSummarySlideComponent } from '../slides/executive-summary-slide/executive-summary-slide.component';
import { InfluencersByMediaTypeSlideComponent } from '../slides/influencers-by-media-type-slide/influencers-by-media-type-slide.component';
import { LanguagesSlideComponent } from '../slides/languages-slide/languages-slide.component';
import { MentionsByMediaTypeSlideComponent } from '../slides/mentions-by-media-type-slide/mentions-by-media-type-slide.component';
import { PlaceholderSlideComponent } from '../slides/placeholder-slide/placeholder-slide.component';
import { TopInfluencersByVoiceShareSlideComponent } from '../slides/top-influencers-by-voice-share-slide/top-influencers-by-voice-share-slide.component';
import { SentimentByMediaTypeSlideComponent } from '../slides/sentiment-by-media-type-slide/sentiment-by-media-type-slide.component';
import { TopCountriesSlideComponent } from '../slides/top-countries-slide/top-countries-slide.component';
import { TrendingHashtagsSlideComponent } from '../slides/trending-hashtags-slide/trending-hashtags-slide.component';
import { WebsiteTrafficDemographicsSlideComponent } from '../slides/website-traffic-demographics-slide/website-traffic-demographics-slide.component';
import { TopSitesByVisitsSlideComponent } from '../slides/top-sites-by-visits-slide/top-sites-by-visits-slide.component';
import { CoverPageSlideComponent } from '../slides/cover-page-slide/cover-page-slide.component';
import { CustomBlockSlideComponent } from '../slides/custom-block-slide/custom-block-slide.component';
import { TrendingConversationsSlideComponent } from '../slides/trending-conversations-slide/trending-conversations-slide.component';
import { VolumeOfMentionsReachSlideComponent } from '../slides/volume-of-mentions-reach-slide/volume-of-mentions-reach-slide.component';
import { SentimentOverTimeSlideComponent } from '../slides/sentiment-over-time-slide/sentiment-over-time-slide.component';
import { EmotionOverTimeSlideComponent } from '../slides/emotion-over-time-slide/emotion-over-time-slide.component';

export const SLIDE_REGISTRY: Partial<Record<SlideType, Type<unknown>>> = {
	cover_page: CoverPageSlideComponent,
	executive_summary: ExecutiveSummarySlideComponent,
	volume_of_mentions_reach: VolumeOfMentionsReachSlideComponent,
	sentiment_over_time: SentimentOverTimeSlideComponent,
	emotion_over_time: EmotionOverTimeSlideComponent,
	sentiment_by_media_type: SentimentByMediaTypeSlideComponent,
	emotion_analysis: EmotionAnalysisSlideComponent,
	top_influencers_by_voice_share: TopInfluencersByVoiceShareSlideComponent,
	top_sites_by_visits: TopSitesByVisitsSlideComponent,
	influencers_by_media_type: InfluencersByMediaTypeSlideComponent,
	best_time_to_post: BestTimeToPostSlideComponent,
	website_traffic_demographics: WebsiteTrafficDemographicsSlideComponent,
	top_countries: TopCountriesSlideComponent,
	trending_hashtags: TrendingHashtagsSlideComponent,
	trending_conversations: TrendingConversationsSlideComponent,
	mentions_by_media_type: MentionsByMediaTypeSlideComponent,
	languages: LanguagesSlideComponent,
	custom_block: CustomBlockSlideComponent
};

export function resolveSlide(slideType: SlideType): Type<unknown> {
	return SLIDE_REGISTRY[slideType] ?? PlaceholderSlideComponent;
}
